// extracted by mini-css-extract-plugin
module.exports = {"root":"organizers_root__yMIEU","title":"organizers_title__d2RUl"};